/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_errors_500_title = /** @type {(inputs: {}) => string} */ () => {
	return `Chyba interního serveru`
};

const da_errors_500_title = /** @type {(inputs: {}) => string} */ () => {
	return `Intern serverfejl`
};

const de_errors_500_title = /** @type {(inputs: {}) => string} */ () => {
	return `Interner Serverfehler`
};

const en_errors_500_title = /** @type {(inputs: {}) => string} */ () => {
	return `Internal server error`
};

const es_errors_500_title = /** @type {(inputs: {}) => string} */ () => {
	return `Error interno del servidor`
};

const fr_errors_500_title = /** @type {(inputs: {}) => string} */ () => {
	return `Erreur interne du serveur`
};

const hu_errors_500_title = /** @type {(inputs: {}) => string} */ () => {
	return `Belső szerverhiba`
};

const it_errors_500_title = /** @type {(inputs: {}) => string} */ () => {
	return `Errore interno del server`
};

const nl_errors_500_title = /** @type {(inputs: {}) => string} */ () => {
	return `Interne serverfout`
};

const pl_errors_500_title = /** @type {(inputs: {}) => string} */ () => {
	return `Błąd serwera`
};

const pt_errors_500_title = /** @type {(inputs: {}) => string} */ () => {
	return `Erro interno do servidor`
};

const sv_errors_500_title = /** @type {(inputs: {}) => string} */ () => {
	return `Internt serverfel`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const errors_500_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.errors_500_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("errors_500_title", locale)
	if (locale === "cs") return cs_errors_500_title(inputs)
	if (locale === "da") return da_errors_500_title(inputs)
	if (locale === "de") return de_errors_500_title(inputs)
	if (locale === "en") return en_errors_500_title(inputs)
	if (locale === "es") return es_errors_500_title(inputs)
	if (locale === "fr") return fr_errors_500_title(inputs)
	if (locale === "hu") return hu_errors_500_title(inputs)
	if (locale === "it") return it_errors_500_title(inputs)
	if (locale === "nl") return nl_errors_500_title(inputs)
	if (locale === "pl") return pl_errors_500_title(inputs)
	if (locale === "pt") return pt_errors_500_title(inputs)
	return sv_errors_500_title(inputs)
};
export { errors_500_title as "errors.500.title" }